import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldType, type FieldTypeConfig, type FormlyFieldProps } from '@ngx-formly/core';

export interface BuilderWarningProps extends FormlyFieldProps {
  /** The warning to show. Empty = nothing is drawn, the live region stays in place. */
  text?: string;
}

/**
 * A warning line under a form-builder editor, separate from the editor's hint text. The live region
 * is always in the DOM so a warning that appears after a pick is announced; colours are the
 * warning badge tokens, which carry light and dark values (contrast 5.3:1 / 7.8:1).
 */
@Component({
  selector: 'formly-builder-warning',
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div role="status" data-cy="builder-warning">
      @if (props.text) {
        <div
          class="mb-4 flex gap-2 rounded-lg bg-[var(--dd-badge-warning-bg)] p-3 text-sm text-[color:var(--dd-badge-warning-fg)]">
          <mat-icon class="shrink-0 icon-size-5 text-current" svgIcon="heroicons_outline:exclamation-triangle" />
          <span>{{ props.text }}</span>
        </div>
      }
    </div>
  `,
})
export class BuilderWarningComponent extends FieldType<FieldTypeConfig<BuilderWarningProps>> {}
